// src/OrderService.js
const API_BASE_URL = "https://chart.flaze.ai/api";

class OrderService {
  static async fetchOrder(ref, setOrder, setError) {
    try {
      const response = await fetch(`${API_BASE_URL}/visualizations/${ref}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        setError(`Error fetching visualizations for ${ref}`);
        setOrder(null);
        return;
      }

      const data = await response.json();
      setOrder(JSON.parse(data.fullData));
      setError(null);
    } catch (error) {
      setError("Error fetching order");
      setOrder(null);
    }
  }
}

export default OrderService;
